/** Kıyas kaynağı: kurumsal baz | bu senaryonun son yayını. */

export const KIYAS_BAZ = "baz";
export const KIYAS_SON_YAYIN = "son_yayin";
export const KIYAS_STORAGE_KEY = "owsuite.freqopt.kiyas.v1";

export function normalizeKiyasKaynagi(value) {
  const v = String(value || "").trim().toLowerCase();
  return v === KIYAS_SON_YAYIN ? KIYAS_SON_YAYIN : KIYAS_BAZ;
}

/** Özet / kurulumda tek satır etiket — kısa, kullanıcı dilinde. */
export function kiyasKaynagiLabel(value) {
  return normalizeKiyasKaynagi(value) === KIYAS_SON_YAYIN
    ? "Bu senaryonun son yayını"
    : "Kurumsal baz";
}

/** Çalışma senaryosunda SSD / son yayın kullanılabilir mi? */
export function sonYayinUygunMu(aktifSenaryo, bulk) {
  if (!aktifSenaryo?.id) return false;
  if (String(aktifSenaryo.rol || "").toLowerCase() === "baz") return false;
  const sefer = Number(aktifSenaryo.metrikler?.sefer_sayisi || 0);
  if (sefer > 0) return true;
  const publishedSid = Number(aktifSenaryo.id);
  const durumlar = bulk?.hatDurumlari || {};
  return Object.values(durumlar).some((d) => {
    if (!d?.published_at) return false;
    const sid = d.published_senaryo_id;
    return sid == null || Number(sid) === publishedSid;
  });
}

export function donemBazSenaryoId(senaryolar) {
  const baz = (senaryolar || []).find((s) => String(s?.rol || "").toLowerCase() === "baz");
  return baz?.id ?? null;
}

export function resolveKiyasSenaryoId(kiyasKaynagi, { aktifSenaryo, senaryolar, bulk } = {}) {
  const kaynak = normalizeKiyasKaynagi(kiyasKaynagi);
  if (kaynak === KIYAS_SON_YAYIN && sonYayinUygunMu(aktifSenaryo, bulk)) {
    return aktifSenaryo.id ?? null;
  }
  return donemBazSenaryoId(senaryolar);
}

export function defaultKiyasKaynagi(aktifSenaryo, bulk) {
  return sonYayinUygunMu(aktifSenaryo, bulk) ? KIYAS_SON_YAYIN : KIYAS_BAZ;
}

export function loadKiyasMap() {
  if (typeof localStorage === "undefined") return {};
  try {
    const raw = JSON.parse(localStorage.getItem(KIYAS_STORAGE_KEY) || "{}");
    return raw && typeof raw === "object" ? raw : {};
  } catch {
    return {};
  }
}

export function persistKiyasForSenaryo(senaryoId, kiyasKaynagi) {
  if (typeof localStorage === "undefined" || senaryoId == null) return;
  try {
    const map = loadKiyasMap();
    map[String(senaryoId)] = normalizeKiyasKaynagi(kiyasKaynagi);
    localStorage.setItem(KIYAS_STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* kota */
  }
}

export function rememberedKiyasKaynagi(senaryoId, aktifSenaryo, bulk) {
  if (senaryoId == null) return defaultKiyasKaynagi(aktifSenaryo, bulk);
  const remembered = loadKiyasMap()[String(senaryoId)];
  if (remembered) {
    const n = normalizeKiyasKaynagi(remembered);
    if (n === KIYAS_SON_YAYIN && !sonYayinUygunMu(aktifSenaryo, bulk)) {
      return KIYAS_BAZ;
    }
    return n;
  }
  return defaultKiyasKaynagi(aktifSenaryo, bulk);
}
